// material-ui
import { useTheme } from "@mui/material/styles";
import { ThemeMode } from "types/config";
import logo from "assets/images/logo-login.png";
import { Typography } from "@mui/material";

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const LogoMain = ({ reverse, ...others }: { reverse?: boolean }) => {
  const theme = useTheme();

  return (
    <>
      <img
        src={logo}
        style={{ height: "50px", width: "50px", marginRight: "1vh" }}
        alt="logo"
        width="100%"
      />
      <Typography variant="h4" sx={{ letterSpacing: "-1px" }}>
        Artisan Flo
      </Typography>
    </>
  );
};

export default LogoMain;
